import axiosPublicClient from "../../../../axiosPublicClient"

export default async (key) => {

    const result = await axiosPublicClient.get(`/pre-check-form?key=${key}`)

    return result.data

}
